import { StreamMetadata } from "./streamMetadata";
import { LogicalLevelTechnique } from "./logicalLevelTechnique";
import { PhysicalLevelTechnique } from "./physicalLevelTechnique";
import { MortonEncodedStreamMetadata } from "./mortonEncodedStreamMetadata";
import { RleEncodedStreamMetadata } from "./rleEncodedStreamMetadata";
export class StreamMetadataDecoder {
    static decode(tile, offset) {
        const streamMetadata = StreamMetadata.decode(tile, offset);
        if (streamMetadata.logicalLevelTechnique1 === LogicalLevelTechnique.MORTON) {
            return MortonEncodedStreamMetadata.decodePartial(streamMetadata, tile, offset);
        }
        if ((LogicalLevelTechnique.RLE === streamMetadata.logicalLevelTechnique1 ||
            LogicalLevelTechnique.RLE === streamMetadata.logicalLevelTechnique2) &&
            PhysicalLevelTechnique.NONE !== streamMetadata.physicalLevelTechnique) {
            return RleEncodedStreamMetadata.decodePartial(streamMetadata, tile, offset);
        }
        return streamMetadata;
    }
}
//# sourceMappingURL=streamMetadataDecoder.js.map